// Developer View as (2026-10-21): shown while this tab shows one customer login's dashboard, and on the developer's
// own login while a session is still on in another tab (that keeps the developer's login read-only until it ends).
// A slim strip above the menu bar, not sticky: the menus' dropdowns must never open underneath it (owner 2026-10-22).
import React, { useState } from 'react';
import { useImpersonation } from '../context/ImpersonationContext';
import { useAuth } from '../context/AuthContext';

const bar = { display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'flex-start', gap: '8px',
  padding: '3px 16px', color: '#fff', fontSize: '12px', lineHeight: 1.4 };
const button = { padding: '1px 10px', borderRadius: '4px', border: '1px solid #fde68a', backgroundColor: 'transparent',
  color: '#fff', cursor: 'pointer', fontSize: '12px' };

export default function ViewAsBanner() {
  const { isImpersonating, targetUser, timeRemaining, stopImpersonation, sessionElsewhere } = useImpersonation();
  const { organization } = useAuth();
  const [busy, setBusy] = useState(false);
  const exit = async () => { setBusy(true); await stopImpersonation(); };
  if (isImpersonating) {
    const minutes = Math.max(1, Math.ceil((timeRemaining || 0) / 60));
    return (
      <div role="status" data-testid="view-as-banner" style={{ ...bar, backgroundColor: '#92400e' }}>
        <span>
          Viewing as <strong>{targetUser.name}</strong>{targetUser.email && targetUser.email !== targetUser.name ? ` (${targetUser.email})` : ''}
          {targetUser.role ? ` - ${targetUser.role}` : ''}{organization?.name ? ` in ${organization.name}` : ''}
          {' '}- read-only, ends in {minutes} min
        </span>
        <button type="button" onClick={exit} disabled={busy} style={button}>Exit</button>
      </div>
    );
  }
  if (!sessionElsewhere) return null;
  return (
    <div role="status" style={{ ...bar, backgroundColor: '#92400e' }}>
      <span>
        A View as session for <strong>{sessionElsewhere.profile?.email || 'a login'}</strong> is still on (another tab),
        so your login is read-only.
      </span>
      <button type="button" onClick={exit} disabled={busy} style={button}>End it</button>
    </div>
  );
}
